<template>
	<div class="row d-flex justify-content-center pb-3 mb-3">
		<div class="col-12 col-sm-12 col-md-6 mt-2">
			<div class="row d-flex justify-content-center align-items-center">
				<div class="col-4">
					Rögzítés dátuma: 
				</div>
				<div class="col-8 text-left">
					{{datum}}
				</div>
			</div>
		</div>
		<div class="col-12 col-sm-12 col-md-6 mt-2">
			<div class="row d-flex justify-content-center align-items-center">
				<div class="col-4">
					Rögzítette:
				</div>
				<div class="col-8 text-left">
					{{user.nev}}
				</div>
			</div>
		</div>
		<div class="col-12 col-sm-12 col-md-6 mt-2">
			<div class="row d-flex justify-content-center align-items-center">
				<div class="col-4">
					Kiszállítás kért dátuma:
				</div>
				<div class="col-8 text-left">
					<div class="row d-flex align-items-center">
						<div class="col-6">
							<date-picker
								v-model="rend_datum"
								:config="date_options"
								@dp-change="refreshdate"
								class="form-control text-center"
							>
							</date-picker>
						</div>
						<div class="col-4">
							{{rend_datum | day}}
						</div>
					</div>
					
				</div>
			</div>
		</div>
		<div class="col-12 col-sm-12 col-md-6 mt-2">
			<div class="row d-flex justify-content-center align-items-center">
				<div class="col-4">
					Rendelésszám:
				</div>
				<div class="col-8 text-left">
					{{rendszam}}
				</div>
			</div>
		</div>
		<div class="col-12 col-sm-12 col-md-6 mt-2">
			<div class="row d-flex justify-content-center align-items-center">
				<div class="col-4">
					Vevő:
				</div>
				<div class="col-8 text-left">
					{{rend_sel_customer.nev}}
				</div>
			</div>
		</div>
		<div class="col-12 col-sm-12 col-md-6 mt-2">
			<div class="row d-flex justify-content-center align-items-center">
				<div class="col-4">
					Számla kiállító:
				</div>
				<div class="col-8 text-left">
					{{rend_sel_customer.szolgnev || `Nincs beállítva`}}
				</div>
			</div>
		</div>
		<div class="col-12 col-sm-12 col-md-6 mt-2">
			<div class="row d-flex justify-content-center align-items-center">
				<div class="col-4">
					Vevő címe:
				</div>
				<div class="col-8 text-left">
					{{rend_sel_customer.varos}} | {{rend_sel_customer.cim}}
				</div>
			</div>
		</div>
		<div class="col-12 col-sm-12 col-md-6 mt-2">
			<div class="row d-flex justify-content-center align-items-center">
				<div class="col-4">
					Szállítási cím:
				</div>
				<div class="col-8 text-left">
					{{rend_sel_customer.szalvaros}} | {{rend_sel_customer.szalcim}}
				</div>
			</div>
		</div>
		<div class="col-12 col-sm-12 col-md-6 mt-2">
			<div class="row d-flex justify-content-center align-items-center">
				<div class="col-4">
					Régió kód:
				</div>
				<div class="col-8 text-left">
					{{rend_sel_customer.regio}}
				</div>
			</div>
		</div>
		<div class="col-12 col-sm-12 col-md-6 mt-2">
			<div class="row d-flex justify-content-center align-items-center">
				<div class="col-4">
					Telefon számok:
				</div>
				<div class="col-8 text-left">
					{{ tel }}
				</div>
			</div>
		</div>
		<lastorder
			class="col-12 pt-2 text-center"
			:customer="rend_sel_customer.id"
		>
		</lastorder>

		<highlighted-products class="col-12 pt-2 text-center">
		</highlighted-products>
		
		<products
			class="col-12 pt-2 text-center"
			:allProducts="true"
		>
		</products>

		<cartv2 class="col-12 pt-2 text-center">
		</cartv2>
		
	</div>
</template>
<script>
import lastorder from '../lastorder'
import products from '../products'
import cartv2 from '@/components/cart/cart_v2'
import highlightedProducts from '../highlightedProducts'
import { mapGetters, mapActions } from 'vuex'
import Vue from 'vue'
export default {
	name: 'order_products',

	components: {
		lastorder,
		products,
		highlightedProducts,
		cartv2
	},

	data(){
		return {
		    rend_datum: this.$moment(new Date()).add(1,'day').format('YYYY-MM-DD')
		}
	},

	mounted(){
		if(!this.$route.query.plus) {
			this.setrendszam(`${this.$moment().unix()}${this.user.azon}`)
			this.refreshdate()
			this.rend_datum = this.$moment(new Date()).add(1,'day').format('YYYY-MM-DD')
		} else {
			this.rend_datum = this.renddatum
		}
	},

	methods: {
		...mapActions(['setrendszam','setrenddatum']),

		refreshdate(){
			this.setrenddatum(this.rend_datum)
		}
	},
	
	computed: {
		tel() {
			let v = Vue.filter('tel')(this.rend_sel_customer.telv)
			let m = Vue.filter('tel')(this.rend_sel_customer.telm)
			return `${v}${v&&m?' - ':''}${m}`
		},

		datum(){
			return this.$moment().format('YYYY-MM-DD HH:mm')
		},
		
    	...mapGetters(['rend_sel_customer','user','rendszam','renddatum']),
  	}
}
</script>


// WEBPACK FOOTER //
// src/components/orders/new_order/order_products2.vue